module.exports = __webpack_public_path__ + "img/T923.6fa930f2.jpg";